import { Box, Tooltip, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';
import { useManagementUser } from 'src/components/management-user';

// ----------------------------------------------------------------------

type Props = {
  row: any;
  handleEditContact?: (id: string) => void;
  handleResendMail?: (id: string) => void;
  handleLoginAsUser?: (row: any) => void;
  handleDeleteRecord?: (id: string) => void;
  moduleName?: string;
  userRole?: string;
  isDelete?: boolean;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellResendMail({
  row,
  handleEditContact,
  handleResendMail,
  handleLoginAsUser,
  handleDeleteRecord,
  moduleName,
  userRole,
  isDelete,
  t,
}: Props) {
  const { isManagement: isManagementFromHook } = useManagementUser();
  const isManagement = isManagementFromHook || userRole?.toLowerCase() === 'management';

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      {/* EDIT BTN */}
      <Tooltip title={t('EDIT')}>
        <span>
          <IconButton
            disabled={isManagement}
            onClick={() => !isManagement && 'id' in row && handleEditContact?.(row.id)}
            sx={{
              transition: 'all 0.2s ease-in-out',
              ...(!isManagement && {
                '&:hover': {
                  transform: 'scale(1.1)',
                  backgroundColor: 'primary.light',
                },
              }),
            }}
          >
            {'Settingname' in row ? (
              <Iconify icon="solar-settings-bold-duotone" />
            ) : (
              <Iconify icon="solar:pen-bold" />
            )}
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={t('RESEND_MAIL')}>
        <span>
          <IconButton
            disabled={Boolean('isEmailVerified' in row && row.isEmailVerified)}
            color="primary"
            onClick={() => 'id' in row && handleResendMail?.(row.id)}
            sx={{
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.1)',
                backgroundColor: 'primary.light',
              },
            }}
          >
            <Iconify icon="mdi:email-resend" sx={{ width: 20, height: 20 }} />
          </IconButton>
        </span>
      </Tooltip>

      {moduleName === 'USER' && userRole === 'Super Admin' && (
        <Tooltip title={t('AUTO_LOGIN')}>
          <span>
            <IconButton
              onClick={() => 'id' in row && handleLoginAsUser?.(row)}
              sx={{
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.1)',
                  backgroundColor: 'primary.light',
                },
              }}
            >
              <Iconify icon="solar-copy-bold" />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {isDelete && (
        <Tooltip title={t('DELETE')}>
          <span>
            <IconButton
              color="error"
              onClick={() => 'id' in row && handleDeleteRecord?.(row.id)}
              sx={{
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.1)',
                  backgroundColor: 'error.light',
                },
              }}
            >
              <Iconify
                icon="material-symbols-light:delete-outline"
                sx={{ color: 'var(--palette-error-main) !important' }}
              />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
}
